import { type RefCallback, useEffect, useRef } from "react";
import type { FormState } from "react-hook-form";

/**
 * Create a function that connects React-Hook-Form's ref with a MUI Select so that it scrolls properly on error
 * @param ref
 */
export function makeSelectRef4RHF(ref: RefCallback<unknown>) {
  return (x: unknown) => {
    if (x instanceof HTMLElement) {
      ref({ focus: () => x.scrollIntoView() });
    }
  };
}

export function useConfirmBeforeUnload(formState: FormState<any>) {
  const dirtyRef = useRef(formState.isDirty);
  dirtyRef.current = formState.isDirty;
  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      if (dirtyRef.current) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, []);
}
